import { Validator, VARIABLE_VALIDATION_REGEX } from './Validator';
import { ValidationError } from './ValidatorError';
export class ExecuteScriptActionSettingsValidator extends Validator {
    validate(model) {
        if (!model.source) {
            throw new ValidationError('The script source is required');
        }
        if (model.inputVariables) {
            model.inputVariables.forEach(inputVariable => {
                if (!inputVariable.match(VARIABLE_VALIDATION_REGEX)) {
                    throw new ValidationError('The script input variable name should be composed only by letters, numbers and dots');
                }
            });
        }
        if (!model.outputVariable) {
            throw new ValidationError('The script output variable is required');
        }
        if (!model.outputVariable.match(VARIABLE_VALIDATION_REGEX)) {
            throw new ValidationError('The script output variable name should be composed only by letters, numbers and dots');
        }
    }
}
